import styled from 'styled-components';

interface ProviderCardProps {
  selected?: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .providers-grid {
    display: grid;
    grid-template-columns: repeat(4, 90px);
    gap: 24px;
    justify-content: center;
  }
`;

export const ProviderCard = styled.button<ProviderCardProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 90px;
  height: 90px;
  border-radius: 16px;
  border: 2px solid ${(props) => (props.selected ? '#2b6a4e' : '#e2e8f0')};
  background: ${(props) => (props.selected ? '#f0faf5' : '#fff')};
  cursor: pointer;
  transition: all 0.2s;
  padding: 12px;

  &:hover {
    border-color: #2b6a4e;
    background: #f0faf5;
  }

  .provider-icon {
    width: 36px;
    height: 36px;
    object-fit: contain;
  }

  .provider-name {
    font-size: 12px;
    font-weight: 500;
    color: #4a5568;
  }
`;
